<template>
  <div>
    <div class="item">
      <div class="icon-font" @click="openBook">e</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["book", "page"],
  methods: {
    openBook() {
      let routeData = this.$router.resolve({
        name: "bookOnly",
        params: { book: this.book, page: this.page },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  height: 70px;
  width: 70px;
  background-color: var(--custom-color1);
  border-radius: 50%;
}
.icon-font {
  border-radius: 50%;
  font-size: 80px;
  text-align: center;
  // width: 30px;
  height: 70px;
  line-height: 70px;
  color: white;
  &.active {
    background-color: #0000001f;
    border: 1px solid 0000001f;
  }
}
.icon-font:hover {
  color: darkgray;
  background-color: #00000014;
  cursor: pointer;
}
</style>
